export const EXTERNAL_URLS = {
  profileImageBaseUrl: 'https://adhoc.rd.astrazeneca.net/api/thumbs',
  vendorTranslation: 'https://translate-dev.sd.astrazeneca.com/web/translate/vendor-upload',
  myQuotes: 'https://translate-dev.sd.astrazeneca.com/web/translate/vendor-orders',
  ngsServiceRequests: 'https://translate-dev.sd.astrazeneca.com/web/ngs/service-request',
  translationManager: 'https://translate-dev.sd.astrazeneca.com/web/translate/view-documents',
  admin: 'https://translate-dev.sd.astrazeneca.com/web/admin',
  azureLoginBanner: 'https://aadcdn.msftauthimages.net/c1c6b6c8-ssimvxpb9qdv8nffqqltxmis1nxfqs5utx0cwh6q-vm/logintenantbranding/0/bannerlogo?ts=638043642020989581',
} as const;
